<template>
	<div class="container">
		<div class="main_box">
			<!--联系我们-->
			<fixed></fixed>
			<!--联系我们-->
			<!--导航-->
			<navbar></navbar>
			<!--导航-->
			<!--引导块-->
			<div
				v-if="infoData"
				class="tips_box"
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<div class="tips_main">
					<span>Home&nbsp;&nbsp;>&nbsp;&nbsp;Products&nbsp;&nbsp;>&nbsp;&nbsp;{{ infoData.parent_name }}&nbsp;&nbsp;>&nbsp;&nbsp;</span>{{ infoData.title }}
				</div>
			</div>
			<!--引导块-->
			<!--banner-->
			<div class="banner_box">
				<img
					class="bg"
					src="../../assets/ag/banner_bg.webp"
					data-aos="fade-in"
					data-aos-duration="400"
					data-aos-delay="100"
					data-aos-offset="0"
					data-aos-once="true"
				/>
				<div class="msg_box">
					<div class="left">
						<div class="tit"
							data-aos="fade-right"
							data-aos-duration="400"
							data-aos-delay="200"
							data-aos-offset="0"
							data-aos-once="true"
						>
							<img src="../../assets/ag/banner_text_01.webp" />
						</div>
						<div class="txt"
							data-aos="fade-right"
							data-aos-duration="400"
							data-aos-delay="400"
							data-aos-offset="0"
							data-aos-once="true"
						>
							<img src="../../assets/ag/banner_text_02.webp" />
						</div>
						<div class="btn_box"
							data-aos="fade-right"
							data-aos-duration="400"
							data-aos-delay="600"
							data-aos-offset="0"
							data-aos-once="true"
						>
							<img src="../../assets/ag/banner_Button_01.webp" style="margin-right: 30px;" @click="goAl21" />
							<img src="../../assets/ag/banner_Button_02.webp" @click="goAmazon" />
						</div>
					</div>
				</div>
			</div>
			<!--banner-->
			<!--表单-->
			<!-- <div
				class="form_box"
				data-aos="fade-up"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<div class="form_main">
					<div class="title">
						<span class="col_org">Limited time offer!</span><br />
						<span class="">Sign up and receive 20% Off</span>
					</div>
					<div class="iframe_box">
						<iframe :src="formUrl" width="100%" height="310px" frameborder="0" allowfullscreen></iframe>
					</div>
				</div>
			</div> -->
			<div class="form_box"
				data-aos="fade-up"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<div class="form_main">
					<div class="title"
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-delay="300"
						data-aos-offset="0"
						data-aos-once="true"
					>
						<span class="">Limited time offer!</span><br />
						<span class="">Sign up NOW, Take 30% off your first purchase</span>
					</div>
					<div class="btn_box"
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-delay="800"
						data-aos-offset="0"
						data-aos-once="true"
						style="padding-top: 20px;"
					>
						<img src="../../assets/3in1/sign-up_icon2.webp" style="width: 38%;" @click="goForm" />
					</div>
				</div>
			</div>
			<!--表单-->
			<!--视频-->
			<div
				class="video_box"
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<div class="video_main">
					<div class="title">CorDx Tyfast COVID-19 Ag Rapid Test</div>
					<iframe width="100%" height="300" src="https://www.youtube.com/embed/MYOAgSybXwE" title="CorDx Easy-Use Covid 19 Test kits" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
				</div>
			</div>
			<!--视频-->
			<!--块1-->
			<div class="block_1">
				<div class="block_1_main">
					<div class="title"
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					>
						<span class="col_org">COVID-19?</span>
					</div>
					<div class="text"
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					>
						Unsure if your respiratory symptoms, such as fever, sneezing, cough, or fatigue, are from COVID?<br />
						With our at-home rapid test, quickly find out and get the right care for you and your family.
					</div>
					<div class="list_box"
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					>
						<div class="list_el">
							<img src="../../assets/ag/img_03.webp" />
							<div class="tit">Fever or Chills</div>
						</div>
						<div class="list_el">
							<img src="../../assets/ag/img_04.webp" />
							<div class="tit">Cough</div>
						</div>
						<div class="list_el">
							<img src="../../assets/ag/img_05.webp" />
							<div class="tit">Difficulty Breathing</div>
						</div>
						<div class="list_el">
							<img src="../../assets/ag/img_06.webp" />
							<div class="tit">Fatigue</div>
						</div>
					</div>
				</div>
			</div>
			<!--块1-->
			<!--块2-->
			<div class="block_2"
				data-aos="fade-up"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<img class="bg" src="../../assets/ag/img_13.webp" />
				<div class="block_2_main">
					<div class="tit_box">
						<div class="tit">
							Simple Testing, <span class="col_org">Reliable Outcomes</span>
						</div>
						<div class="txt">
							Protect yourself and your loved ones year-round. Ideal<br />
							for monitoring symptoms and preventing the spread<br />
							of seasonal illnesses.
						</div>
					</div>
					<div class="img_box">
						<img src="../../assets/ag/img_16.webp" />
					</div>
				</div>
			</div>
			<!--块2-->
			<!--块3-->
			<div class="block_3"
				data-aos="fade-up"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<img class="bg" src="../../assets/ag/img_14.webp" />
				<div class="block_3_main">
					<div class="tit_box">
						<div class="tit">
							Feel Unsure?<br /><span class="col_org">No More Guessing!</span>
						</div>
						<div class="txt">
							Get clear and accurate results within 5 days<br />
							of onset symptoms. Feel confident and<br />
							prepared to take the right steps, fast.
						</div>
					</div>
				</div>
			</div>
			<!--块3-->
			<!--块4-->
			<div class="block_4">
				<div class="block_4_main">
					<div class="title"
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					>
						<span class="col_org">Simple Testing, </span>Reliable Outcomes
					</div>
					<div class="text"
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					>
						Protect yourself and your loved ones year-round. Ideal for monitoring symptoms and preventing<br />
						the spread of seasonal illnesses.
					</div>
					<div class="list_box"
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					>
						<div class="list_el">
							<img src="../../assets/ag/img_07.webp" />
							<div class="tit">Swab Nostrils</div>
						</div>
						<div class="list_el">
							<img src="../../assets/ag/img_08.webp" />
							<div class="tit">Mix Sample & Solution</div>
						</div>
						<div class="list_el">
							<img src="../../assets/ag/img_09.webp" />
							<div class="tit">Add 3 Drops</div>
						</div>
						<div class="list_el">
							<img src="../../assets/ag/img_10.webp" />
							<div class="tit">Wait</div>
						</div>
					</div>
					<div class="tips">*please refer to the guick reference instructions or the instructional video for more detailed steps.</div>
				</div>
			</div>
			<!--块4-->
			<!--块5-->
			<div class="block_5"
				data-aos="fade-up"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<img class="bg" src="../../assets/ag/img_15.webp" />
				<div class="block_5_main">
					<div class="tit_box">
						<div class="tit">
							<span class="col_org">Ready</span> for All Occasions
						</div>
						<div class="txt">
							Its compact design assures not only easy storage but also convenient portability in your travel bag, allowing you to seamlessly take charge of your health wherever you go.
						</div>
					</div>
				</div>
			</div>
			<!--块5-->
			<!--块6-->
			<div class="block_6">
				<div class="block_6_main">
					<div class="title">Downloadable Resources</div>
					<template v-if="infoData">
						<div v-if="infoData.tags.length > 0" class="tag_box"
							data-aos="fade-in"
							data-aos-duration="400"
							data-aos-delay="100"
							data-aos-offset="0"
							data-aos-once="true"
						>
							<div class="list_box">
								<div v-for="(value, index) in infoData.tags" :key="index"
									class="list_el"
									:class="nowList == value.id ? 'actived' : ''"
									@click="listClick(value)"
								>{{ value.catname }}</div>
							</div>
							<div class="content" v-html="nowContent"></div>
						</div>
					</template>
				</div>
			</div>
			<!--块6-->
			<!--版权-->
			<footerBox></footerBox>
			<!--版权-->
		</div>
		<!--loading-->
		<transition name="fade">
			<div class="loading" v-show="isLoading"><van-loading /></div>
		</transition>
		<!--loading-->
	</div>
</template>

<script>
import navbar from '@/component/nav.vue'  //导航组件
import footerBox from '@/component/footer.vue'  //版权组件
import fixed from '@/component/fixed.vue'  //联系我们悬浮
import contact from '@/component/contact2.vue'  //联系我们
import { productInfo, productCount } from '@/api/public';
import md5 from 'js-md5';
import moment from 'moment';
export default {
	components:{
		navbar,
		footerBox,
		fixed
	},
	metaInfo() {
		return {
			meta: [
				{
					name: "description",
					content: this.metaDescription,
				},{
					name: "keywords",
					content: this.metaKeywords,
				}
			]
		}
	},
	data() {
		return {
			isLoading: true,  //界面loading
			infoData: null,
			nowList: null,
			nowContent: '',
			metaDescription: '',
			metaKeywords: '',
			formUrl: 'https://cordx.com/hbspt-form3.html?t='+new Date().getTime()
		}
	},
	created(){
		let that = this;
		window.scroll(0, 0);
		//请求产品信息
		productInfo({
			custom: that.$route.params.productInfoIds,
		}).then(res => {
			that.infoData = res.data;
			document.title = res.data.title + ' - CorDx';
			that.metaDescription = res.data.description;
			that.metaKeywords = res.data.keywords;
			that.setOgTag('og:locale', 'en_US');
			that.setOgTag('og:title', res.data.title);
			that.setOgTag('og:description', res.data.description);
			that.setOgTag('og:image', res.data.url);
			that.setOgTag('og:image:width', '1200');
			that.setOgTag('og:image:height', '630');
			that.setOgTag('og:image:type', 'webp');
			if(that.infoData.tags.length > 0) {
				that.nowList = that.infoData.tags[0].id;
				that.nowContent = that.infoData.tags[0].content;
			}
			that.isLoading = false;
			//统计访问
			let time = String(moment(new Date()).valueOf());
			setTimeout(() => {
				productCount({
					language: sessionStorage.getItem('lang') == 'en' ? 2 : 1,
					cate_id: that.infoData.cate_id,
					cert_id: that.infoData.cert_id,
					productid: that.infoData.id,
					url: that.$route.name,
					addtime: time,
					sign: md5(String(that.infoData.cate_id) + String(that.infoData.cert_id) + String(that.infoData.id) + that.$route.name + String(time) + 'CorDx2023'),
				}).then(res2 => {});
			}, 10000);
		});
	},
	mounted() {
		let that = this;
	},
	watch: {
		//
	},
	methods: {
		//设置OG标签
		setOgTag(property, content) {
			const meta = document.querySelector(`meta[property='${property}']`);
			if(meta) {
				meta.setAttribute('content', content);
			} else {
				const newMeta = document.createElement('meta');
				newMeta.setAttribute('property', property);
				newMeta.setAttribute('content', content);
				document.head.appendChild(newMeta);
			}
		},
		//底部列表点击
		listClick(value) {
			let that = this;
			that.nowList = value.id;
			that.nowContent = value.content;
		},
		goAl21() {
			let that = this;
			window.location.href = that.infoData.buy_url;
		},
		goAmazon() {
			let that = this;
			window.location.href = 'https://www.amazon.com/CorDx-at-Home-COVID-19-Accurate-Minutes/dp/B0DCGQD733/ref=sr_1_2?dib=eyJ2IjoiMSJ9.qPIqXjUO2rxpoT5h05pWhQx6kDgP_v0uorAD6GWXNf8.EKhTgxT-iw6B5dzlM91jcO7Zpw9mTBvmXzxfRY8WDrA&dib_tag=se&m=A1EZ8UG06NJCKU&marketplaceID=ATVPDKIKX0DER&qid=1724849517&s=merchant-items&sr=1-2';
		},
		goForm() {
			let that = this;
			window.location.href = 'https://9503031.extforms.netsuite.com/app/site/crm/externalleadpage.nl?compid=9503031&formid=25&h=AAFdikaI4VJv8AELTp43tVqlz-7RCQf_W_uS19vr4nL8xs5-TRI';
		}
	}
}
</script>

<style scoped lang="less">
.col_org{
	color: #f36f32;
}
.col_blue{
	color: #083388;
}
.main_box{
	//块6
	.block_6{
		padding: 0 20px;
		.block_6_main{
			padding:40px 0 60px 0;
			.bg{
				img{
					width: 100%;
				}
			}
			.tag_box{
				padding: 20px 0 50px 0;
				.content{
					margin-top: 30px;
					padding: 0 30px;
					border: 1px solid #0B318F;
				}
				.list_box{
					.list_el{
						display: inline-block;
						margin: 10px 10px 0 0;
						padding: 12px 20px;
						font-size: 18px;
						background-color: #EFEFEF;
						color: #000000;
						cursor: pointer;
					}
					.list_el.actived{
						color: #ffffff;
						background-color: #0B318F;
					}
					.list_el:hover{
						color: #ffffff;
						background-color: #0066D4;
					}
				}
			}
			.title{
				text-align: center;
				font-size: 24px;
				font-weight: bold;
			}
		}
	}
	//块5
	.block_5{
		position: relative;
		margin-top: 40px;
		.block_5_main{
			width: 100%;
			height: 100%;
			.tit_box{
				padding: 20px;
				width: auto;
				.txt{
					padding-top: 10px;
					font-size: 16px;
					text-align: center;
				}
				.tit{
					font-weight: bold;
					font-size: 24px;
					text-align: center;
					span{
						font-weight: bold;
						font-size: 24px;
					}
				}
			}
		}
		.bg{
			width: 100%;
		}
	}
	//块4
	.block_4{
		.block_4_main{
			width: 100%;
			margin: 0 auto;
			padding: 40px 20px;
			.tips{
				padding-top: 50px;
				font-size: 16px;
				text-align: center;
				color: #333333;
			}
			.list_box{
				padding-top: 40px;
				.list_el{
					flex: 1;
					padding: 10px 0;
					text-align: center;
					.tit{
						padding-top: 15px;
						font-size: 18px;
					}
					img{
						width: 60%;
					}
				}
			}
			.text{
				padding-top: 25px;
				font-size: 16px;
				text-align: center;
			}
			.title{
				font-weight: bold;
				font-size: 24px;
				text-align: center;
				span{
					font-weight: bold;
					font-size: 24px;
				}
			}
		}
	}
	//块3
	.block_3{
		position: relative;
		margin-top: 40px;
		.block_3_main{
			width: 100%;
			height: 100%;
			.tit_box{
				padding: 20px;
				width: auto;
				.txt{
					padding-top: 10px;
					font-size: 16px;
					text-align: center;
				}
				.tit{
					font-weight: bold;
					font-size: 24px;
					text-align: center;
					span{
						font-weight: bold;
						font-size: 24px;
					}
				}
			}
		}
		.bg{
			width: 100%;
		}
	}
	//块2
	.block_2{
		position: relative;
		.block_2_main{
			width: 100%;
			height: 100%;
			.img_box{
				padding: 20px 20px 0 20px;
				img{
					width: 100%;
				}
			}
			.tit_box{
				padding: 20px;
				width: auto;
				.txt{
					padding-top: 10px;
					font-size: 16px;
					text-align: center;
				}
				.tit{
					font-weight: bold;
					font-size: 24px;
					text-align: center;
					span{
						font-weight: bold;
						font-size: 24px;
					}
				}
			}
		}
		.bg{
			width: 100%;
		}
	}
	//块1
	.block_1{
		.block_1_main{
			width: 100%;
			margin: 0 auto;
			padding: 40px 20px;
			.list_box{
				padding-top: 40px;
				.list_el{
					flex: 1;
					padding: 10px 0;
					text-align: center;
					.tit{
						padding-top: 15px;
						font-size: 18px;
					}
					img{
						width: 60%;
					}
				}
			}
			.text{
				padding-top: 25px;
				font-size: 16px;
				text-align: center;
			}
			.title{
				font-weight: bold;
				font-size: 24px;
				text-align: center;
				span{
					font-weight: bold;
					font-size: 24px;
				}
			}
		}
	}
	//视频
	.video_box{
		padding: 30px 20px 0 20px;
		.video_main{
			width: 100%;
			padding: 0px 0 0px 0;
			.title{
				padding-bottom: 20px;
				font-size: 24px;
				font-weight: bold;
				text-align: center;
			}
		}
	}
	//表单
	.form_box{
		margin-top: 30px;
		padding: 30px 0;
		background-color: #FEFBF3;
		.form_main{
			width: 100%;
			margin: 0 auto;
			.btn_box{
				text-align: center;
				img{
					cursor: pointer;
				}
			}
			.title{
				text-align: center;
				span{
					font-size: 20px;
				}
			}
		}
	}
	//表单
	// .form_box{
	// 	.form_main{
	// 		width: 100%;
	// 		margin: 0 auto;
	// 		padding-top: 30px;
	// 		.title{
	// 			padding: 0 0 20px 0;
	// 			text-align: center;
	// 			span{
	// 				font-size: 24px;
	// 				font-weight: bold;
	// 			}
	// 		}
	// 	}
	// }
	//banner
	.banner_box{
		position: relative;
		.msg_box{
			width: 100%;
			padding: 20px;
			.btn_box{
				padding-top: 20px;
				img{
					display: inline-block;
					width: 40%;
					cursor: pointer;
				}
			}
			.left{
				flex: 1;
				.txt{
					padding-top: 20px;
					img{
						width: 100%;
					}
				}
				.tit{
					img{
						width: 80%;
					}
				}
			}
		}
		img.bg{
			width: 100%;
		}
	}
	//引导块
	.tips_box{
		padding: 40px 20px 10px 20px;
		background: linear-gradient(to right, #F2F7FD, transparent);
		.tips_main{
			font-size: 16px;
			span{
				font-size: 16px;
				color: #0B318F;
			}
		}
	}
}
</style>
<style scoped>
>>> .main_box ol,>>> .main_box ul{
	list-style: initial !important;
	margin: revert !important;
	padding: revert !important;
}
>>> .main_box .block_1_box p{
	margin: 0;
}
</style>